import moment from "moment";
import packageJson from "../../package.json";

const useLatestBuild = () => {
	const currentVersionDate = packageJson.buildDate;
	return moment(currentVersionDate);
};

export default useLatestBuild;
